import { Controller } from 'stimulus';

// Opens the browser's date/time picker from anywhere in the field, not only its small built-in icon.
// The input stays a native one, so its value, change/input events and form submission are unchanged.
export default class DateTimeFieldComponentController extends Controller {
  static targets = ['input'];

  open() {
    const input = this.inputTarget;
    if (input.disabled || input.readOnly || typeof input.showPicker !== 'function') return;
    try {
      input.showPicker();
    } catch (_) { /* refused without a user gesture: the field stays editable by keyboard */ }
  }
}
